import React, { useEffect, useState } from 'react';
import { dayMonthYearToIso, isoToDayMonthYear } from '../../shared/date';

interface DayMonthDateInputProps {
  value: string;
  onChange: (isoValue: string) => void;
  className?: string;
  id?: string;
  disabled?: boolean;
  placeholder?: string;
}

const DayMonthDateInput: React.FC<DayMonthDateInputProps> = ({
  value,
  onChange,
  className = 'ah-input',
  id,
  disabled = false,
  placeholder = 'DD/MM/YYYY',
}) => {
  const [displayValue, setDisplayValue] = useState(() => isoToDayMonthYear(value));

  useEffect(() => {
    setDisplayValue(isoToDayMonthYear(value));
  }, [value]);

  const commitValue = (nextDisplay: string) => {
    const trimmed = nextDisplay.trim();
    if (!trimmed) {
      setDisplayValue(isoToDayMonthYear(value));
      return;
    }

    const iso = dayMonthYearToIso(trimmed);
    if (iso) {
      onChange(iso);
      setDisplayValue(isoToDayMonthYear(iso));
      return;
    }

    setDisplayValue(isoToDayMonthYear(value));
  };

  return (
    <input
      id={id}
      type="text"
      inputMode="numeric"
      className={className}
      value={displayValue}
      placeholder={placeholder}
      disabled={disabled}
      onChange={(e) => setDisplayValue(e.target.value)}
      onBlur={() => commitValue(displayValue)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.currentTarget.blur();
        }
      }}
    />
  );
};

export default DayMonthDateInput;
